import { render, staticRenderFns } from "./ot-calendar-details-form.vue?vue&type=template&id=5c3d394b&scoped=true&"
import script from "./ot-calendar-details-form.vue?vue&type=script&lang=ts&"
export * from "./ot-calendar-details-form.vue?vue&type=script&lang=ts&"
import style0 from "./ot-calendar-details-form.vue?vue&type=style&index=0&id=5c3d394b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d394b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VForm,VOverlay})
